module.exports = __webpack_public_path__ + "static/media/iconContact.ca9fc1a0.png";